import React, { Component } from 'react';
import './index.css';

export default class CalculatedClassification extends Component {
  render() {
    return (
      <div className="calculatedClassification">
        Calculated Classification: {this.props.calculatedClassification}
      </div>
    );
  }
}
